const PARTNER_STACK_PUBLIC_KEY = 'pk_ecKksFGVpKQJpoz7vhE9jsH5nyqR2EHc';

const setPartnerStackData = (data: { email?: string; name?: string; customerKey?: string }) => {
  if (typeof window === 'undefined' || !window.growsumo) {
    return;
  }

  if (!window.growsumo.data) {
    window.growsumo.data = {};
  }

  if (data.name) {
    window.growsumo.data.name = data.name;
  }

  if (data.email) {
    window.growsumo.data.email = data.email;
  }

  const customerKey = data.customerKey ?? data.email;
  if (customerKey) {
    window.growsumo.data.customer_key = customerKey;
  }
};

declare global {
  interface Window {
    growsumo?: {
      data?: {
        name?: string;
        email?: string;
        customer_key?: string;
        [key: string]: unknown;
      };
      _initialize?: (key: string) => void;
      createSignup?: () => void;
    };
    growsumoInit?: () => void;
  }
}

export const PARTNER_STACK_SCRIPT_ID = 'partnerstack-script';
export const PARTNER_STACK_SCRIPT_SRC = 'https://try.withtandem.com/pr/js';

export const initializePartnerStack = () => {
  if (typeof window === 'undefined' || !window.growsumo?._initialize) {
    return;
  }

  try {
    window.growsumo._initialize(PARTNER_STACK_PUBLIC_KEY);

    if (typeof window.growsumoInit === 'function') {
      window.growsumoInit();
    }
  } catch (error) {
    console.error('Failed to initialize PartnerStack', error);
  }
};

export const createPartnerStackSignup = (data: { email?: string; name?: string; customerKey?: string }) => {
  if (typeof window === 'undefined' || !window.growsumo?.createSignup) {
    return;
  }

  try {
    setPartnerStackData(data);
    window.growsumo.createSignup();
  } catch (error) {
    console.error('Failed to create PartnerStack signup', error);
  }
};
